import React from 'react';
import { translate } from 'react-i18next';
import { ScrollView, StyleSheet, Text, View, TouchableOpacity } from 'react-native';
import ExclamationSvg from '../../assets/images/exclamation.svg'
import { Button, ButtonTypes } from '../../components';
import Theme from '../../theme';
import { defaultScale, scaleText } from '../../utils/scaling';

interface IProps {
  t: (key: string) => string;
  bodyScanStats: any;
  goToFaq(): void;
  startBodyAssessment(): void;
  openSmartScaleEcomm(): void;
}

class BodyscaleOnboarding extends React.PureComponent<IProps, any> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    const { t, startBodyAssessment, openSmartScaleEcomm, goToFaq } = this.props;
    return (
      <View style={styles.container}>
        <ScrollView contentContainerStyle={styles.scrollerContent}>
          <View style={styles.bodyContainer}>
            <Text style={styles.mainText}>{t('bodyAssessmentIntro')}</Text>
            <View style={styles.subTextContainer}>
              <ExclamationSvg width={defaultScale(28)} height={defaultScale(28)} color={Theme.BLACK}/>
              <Text style={styles.subText}>{t('smartScaleRequired')}</Text>
            </View>
            <View style={styles.flexEndContainer}>
              <TouchableOpacity onPress={goToFaq}>
                <Text style={[styles.link, { color: Theme.PRIMARY }]}>{t('weightTarget:scaleLearnMore')}</Text>
              </TouchableOpacity>
            </View>
          </View>
        </ScrollView>
        <View style={styles.footer}>
          <Button
            title={t('startBodyAssessment')}
            onPress={() => startBodyAssessment()}
            fontColor={Theme.WHITE}
            buttonType={ButtonTypes.NORMAL}
            containerStyle={[styles.submitButtonContainer]}
          />
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  scrollerContent: {
    flexGrow: 1,
  },
  bodyContainer: {
    flex: 1,
    marginTop: defaultScale(35),
  },
  flexEndContainer: {
    flex: 1,
    justifyContent: 'flex-end',
  },
  submitButtonContainer: {
    marginVertical: defaultScale(5),
  },
  mainText: {
    ...Theme.textStyle.heading2,
    textAlign: 'center',
    marginBottom: defaultScale(35),
  },
  subText: {
    ...Theme.textStyle.bodyCopyReg,
    textAlign: 'center',
    marginLeft: defaultScale(10),
  },
  subTextContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
  },
  footer: {
    justifyContent: 'flex-end',
  },
  link: {
    fontFamily: Theme.Weight700,
    fontSize: scaleText(16),
    textAlign: 'center',
    marginBottom: defaultScale(25),
  },
});

export default translate(['bodyscan', 'weightTarget'])(BodyscaleOnboarding);
